/* eslint-disable no-console,@typescript-eslint/no-unused-vars */
const fakeKakao = {
  init(key: string) {
    // empty
    console.log(`[boot/kakao/mock] init key ${key}`)
  },
  Auth: {
    login(options: any) {
      if(options.success) {
        options.success({'access_token': 'kakaoToken'})
      }
    },
  },
}

export default fakeKakao
